import { useEffect } from "react";
import { MolduraDoApp } from "@base/ui";
import { PageLayout } from "@/components/layout/page-header";
import { LogoRenkeRefs } from "../../../shared/branding/logo-renke-refs";
import { usePropsDoSeletorNaMoldura } from "../../../shared/tenant/projeto.contexto";
import { ConteudoDoProjeto } from "../../clientes/presentation/pagina-de-cliente";
import { useNavegacaoDoApp } from "./navegacao-do-app";
import { rodapeDaSessaoNaLateral } from "./rodape-da-sessao";

/**
 * Configurações do projeto ativo (Identidade, Planejamento, Publicação…).
 * Instagram do estúdio e ClickUp ficam em Configurações da conta (#perfil).
 */
export function PaginaDeConfiguracoes() {
  useEffect(() => {
    const query = window.location.hash.split("?")[1] ?? "";
    const params = new URLSearchParams(query);
    const aba = params.get("aba");
    if (aba === "instagram" || aba === "clickup") {
      window.location.hash = `perfil?aba=${aba}`;
      return;
    }
    if (!params.get("secao")) {
      window.location.hash = "configuracoes?secao=perfil";
    }
  }, []);

  const seletorProjeto = usePropsDoSeletorNaMoldura();
  const navegacao = useNavegacaoDoApp("configuracoes");

  return (
    <MolduraDoApp
      nomeDoApp="Creative OS"
      marca={<LogoRenkeRefs />}
      titulo="Configurações do projeto"
      subtitulo="Identidade, planejamento e redes do cliente para publicar"
      navegacao={navegacao}
      rodapeDaLateral={rodapeDaSessaoNaLateral}
      {...seletorProjeto}
    >
      <PageLayout className="animate-aparecer gap-8 pb-24">
        <div className="mx-auto w-full max-w-5xl">
          <ConteudoDoProjeto />
        </div>
      </PageLayout>
    </MolduraDoApp>
  );
}
